import PropTypes from 'prop-types';
import { FileText, AlertCircle } from 'lucide-react';

export const NoSpecificationsEmpty = () => (
  <div className="empty-state">
    <div className="empty-icon">
      <FileText />
    </div>
    <h3>No Specifications Found</h3>
    <p>No clear specifications were extracted from the scope text.</p>
    <div className="empty-suggestions">
      <h4>Possible reasons:</h4>
      <ul>
        <li>The document may not contain clearly defined specifications</li>
        <li>The document format might not be supported for extraction</li>
        <li>Specifications may be in a format that was not recognized</li>
      </ul>
    </div>
  </div>
);

export const NoSubcontractorResults = () => (
  <div className="empty-state">
    <div className="empty-icon">
      <AlertCircle />
    </div>
    <h3>No Quote Analysis Results</h3>
    <p>
      No subcontractor quotes were analyzed against the scope specifications.
    </p>
    <div className="empty-suggestions">
      <h4>This could mean:</h4>
      <ul>
        <li>No quote documents were uploaded with this package</li>
        <li>Quote analysis has not been completed yet</li>
        <li>All quote analyses encountered errors</li>
      </ul>
    </div>
  </div>
);

export const AnalysisNotAvailable = ({ reason }) => (
  <div className="empty-state warning">
    <div className="empty-icon">
      <AlertCircle />
    </div>
    <h3>Scope Analysis Not Available</h3>
    <p>{reason || 'Scope analysis is not available for this package.'}</p>
    <div className="empty-suggestions">
      <h4>This might occur when:</h4>
      <ul>
        <li>No scope document was uploaded</li>
        <li>The scope analysis feature is disabled</li>
        <li>Analysis failed during processing</li>
      </ul>
    </div>
  </div>
);

AnalysisNotAvailable.propTypes = {
  reason: PropTypes.string,
};
